import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetTransferReconciliationAudit } from './hooks';

export default function TransferReconciliationAuditHistory() {
  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetTransferReconciliationAudit();

  const { pageEnum } = useParams();

  return (
    <Layout
      pageEnum={pageEnum}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
